export const siteSsoWP = {
  sso: 'http://u051421.com/wp-admin/admin-ajax.php?action=sso-check&nonce=23da0e48b53dbb1b0ba6acc33db7a84dfa0be81b696964145d7a738e8539196f&salt=50a6921beea24175fd35f98da223e91842030616fc82ab04d8bfa8ce87e91438',
};

export const siteSsoBuilderMulti = (domain: any) => ({
  sso: null,
  type: null,
  other: [
    {
      added: '2023-07-27 22:41:37',
      addon_id: '1111',
      domain: domain || 'webzai-test.com',
      subtype: '',
      type: 'webzai',
    },
    // {
    //   added: '2023-07-27 22:42:37',
    //   addon_id: '2222',
    //   domain: 'webzai-test-2.com',
    //   subtype: '',
    //   type: 'webzai',
    // },
    {
      added: '2023-07-26 20:21:56',
      addon_id: '1234',
      domain: domain || 'weebly-test-1.com',
      subtype: '',
      type: 'weebly',
    },
    {
      added: '2023-07-26 20:21:56',
      addon_id: '4321',
      domain: 'weebly-test-2.com',
      subtype: '',
      type: 'weebly',
    },
  ],
});
